module.exports = __webpack_public_path__ + "img/google_G_logo.b7727941.svg";